import { IEvent } from "../models/Event";
import { getEventDateMs } from "../utils/event-date";


export const StatusBtn: React.FC<{ event: IEvent, goToRegistration?: () => void, className?: string }> = ({ event, goToRegistration, className = 'btn-primary' }) => {
    const isExpired = getEventDateMs(event) < Date.now()
    const btnClassName = `btn ${className}`

    if (isExpired) return <a className={btnClassName} href={event.resultsUrl}>לחץ לתוצאות</a>

    if (event.status === "registration") {
        return goToRegistration
            ? <button type="button" className={btnClassName} onClick={goToRegistration}>לחץ להרשמה</button>
            : <a className={btnClassName} href={event.registrationUrl}>לחץ להרשמה</a>
    }

    if (event.showParticipants) return <a className={btnClassName} href={event.participantsListUrl}>לחץ לרשימת המשתתפים</a>

    return <span className="status-note">ההרשמה הסתיימה</span>
}
